import {DiApi} from '@di-shared/api/di/__generated';
import {DiAxiosHttpRequest} from '@di-shared/api/di/DiAxiosHttpRequest';
import {DiApiEu} from '@di-shared/api/di/__generated_eu';
import {DiAxiosHttpRequestEu} from '@di-shared/api/di/DiAxiosHttpRequestEu';

export const diApi = new DiApi(
  {
    BASE: import.meta.env.VITE_DI_KR_API_URL,
  },
  DiAxiosHttpRequest
);
export const diApiEu = new DiApiEu(
  {
    BASE: import.meta.env.VITE_DI_EU_API_URL,
  },
  DiAxiosHttpRequestEu
);
